/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import Vue from 'vue';
import router from './router';
import VueAnalytics from 'vue-analytics';

window.Vue = Vue;

Vue.component('main-menu', require('./components/MainMenu.vue'));

Vue.use(VueAnalytics, {
  id: gbl.gAnalytics,
  router
});

var FontFaceOnload = require('fontfaceonload');

const app = new Vue({
  router,
  el: '#app',
  data: function() {
    return {
      gbl:gbl,
      loaded: false,
      contentLoaded: false
    };
  },
  mounted() {
    document.getElementById('app').style.display = 'block';
    // wait till font has loaded before loading the page
    new FontFaceOnload("bryant", {
      success: () => {
        setTimeout(() => {
          // menu loading
          this.$nextTick().then(() => {
            this.loaded = true;
          });
          if (window.innerWidth < 993) {
            this.contentLoaded = true;
          } else {
            setTimeout(() => {
              this.contentLoaded = true;
            }, (100 * 7 + 1300));
          }
        }, 500);
      },
      error: function() {
        console.log('couldnt load font');
      },
      timeout: 10000 // in ms. Optional, default is 10 seconds
    });
  },
  methods: {
    scrollToTop() {
      try {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      } catch (e) {
        window.scrollTo(0,0);
      }
    }
  }
});



// WEBPACK FOOTER //
// ./resources/js/app.js